import r from "./_root.js";
var a = r, o = a["__core-js_shared__"], _ = o;
export {
  _ as default
};
//# sourceMappingURL=_coreJsData.js.map
